import React from "react";
export default ({ data: { company_name, industry, price, change } }) => (
  <div className="flex flex-col w-fit h-fill text-left">
    <h1 className="title">{company_name}</h1>
    <h2 className="text-gray-400 subtitle">{industry}</h2>
    <div>${price.toFixed(2)}</div>
    <span
      className={`rounded-3xl w-fit px-4 font-bold py-2 text-left text-sm ${
        change > 0 ? "bg-green-500" : "bg-red-500"
      }`}
    >
      {change.toFixed(2)}
      <span className="ml-2">{change > 0 ? "▲" : "▼"}</span>
    </span>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/header.js